import React from 'react';

import { AuthContext } from '@modules/Auth/contexts/AuthContext';

import { ResetAccountDialog } from '../dialogs/ResetAccount';
import { isResetDue } from '../helpers/resetSchedule';

export const RESET_DISMISS_KEY = 'resetAccountDismissedDate';
const RESET_DELAY_MS = 1500;

const todayKey = () => new Date().toISOString().slice(0, 10);

export const ResetAccountTrigger: React.FC = () => {
  const { user } = React.useContext(AuthContext);
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (!isResetDue(user)) return;
    if (localStorage.getItem(RESET_DISMISS_KEY) === todayKey()) return;
    const timer = window.setTimeout(() => setOpen(true), RESET_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, [user]);

  const handleClose = React.useCallback(() => {
    localStorage.setItem(RESET_DISMISS_KEY, todayKey());
    setOpen(false);
  }, []);

  return <ResetAccountDialog open={open} onClose={handleClose} />;
};
